import { z } from 'zod';
export const workAreaStepSchema = z.object({
    cantonUuids: z.array(z.uuid()),
});
export const cantonSchema = z.object({
    uuid: z.uuid(),
    shortName: z.string(),
    longName: z.string(),
});
export const workAreaOptionsResponseSchema = z.object({
    cantons: z.array(cantonSchema),
});
